import { focusAtom } from 'jotai-optics';
import { appAtom } from './appAtom';

export const moveTaskOrderAtom = focusAtom(appAtom, (optic) =>
  optic.prop('move_task_order')
);
